import {Pipe, PipeTransform} from "@angular/core";
import {MessageTranslateService} from "@app/shared/services";
import moment, {Moment} from 'moment-timezone';
import {I18nMessage} from "@shared/api/model/i18n";


export interface ExpiryDatePipeOptions {
  timezone: string;
  showExpiryDate?: boolean;
  dateFormat?: string;
}


@Pipe({name: 'expiryDate', standalone: false})
export class ExpiryDatePipe implements PipeTransform {

  constructor(private translateService: MessageTranslateService) {}

  transform(expireDate: string | Moment | Date, options: ExpiryDatePipeOptions): string {
    const timezone = options.timezone ?? moment.tz.guess();
    const today = moment().tz(timezone).startOf('day');
    const expiryDate = moment.tz(expireDate, timezone);
    let message: I18nMessage;
    if (expiryDate.isSame(today)) {
      message = {messageKey: 'Expires today'};
    } else {
      const expiresIn = moment.duration(expiryDate.diff(today));
      const expiresInMonths = expiresIn.asMonths();
      if (expiresInMonths >= 1) {
        message = expiresInMonths > 1
          ? {messageKey: 'Expires in number months', parameters: {months: Math.floor(expiresInMonths)}}
          : {messageKey: 'Expires next month'};

      } else {
        const expiresInDays = expiresIn.asDays();
        if (expiresInDays >= 1) {
          message = expiresInDays > 1
            ? {messageKey: 'Expires in number days', parameters: {days: Math.floor(expiresInDays)}}
            : {messageKey: 'Expires tomorrow'};
        } else {
          message = {messageKey: 'Expired'};
        }
      }
    }
    return this.translateService.instant(message) + (options?.showExpiryDate
      ? (' (' + expiryDate.format(options?.dateFormat ?? 'DD MMM YYYY') + ')')
      : '');
  }
}
